import React from 'react';
// ANT
import Button from 'antd/lib/button';

const NextButton = ({ renderBackButton, loading, onNext, disabled }) => {
  return (
    <div>
      <Button
        type="primary"
        size="large"
        disabled={disabled || loading}
        loading={loading}
        className="contract-flow-btn"
        onClick={() => onNext()}
      >
        SAVE & NEXT
      </Button>
      {renderBackButton()}
    </div>
  );
};

NextButton.defaultProps = {
  renderBackButton: () => null,
  onNext: () => null,
};

export default NextButton;



// WEBPACK FOOTER //
// ./src/routes/contract-draft/NextButton/index.js